// 是否移动端
function isMobile(val) {
	return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

// 禁止页面滚动
function stopPageScroll(val) {
	if (val) {
		document.documentElement.style.overflow = 'hidden';
	} else {
		document.documentElement.style.overflow = 'auto';
	}
}

// 返回顶部
function backTop(duration = 500, millisecond = 10) {
	var height = ~parseInt(document.documentElement.scrollTop / (duration / millisecond));
	var timer = setInterval(function() {
		if (document.documentElement.scrollTop > 0) {
			window.scrollBy(0, height);
		} else {
			clearInterval(timer);
		}
	}, millisecond);
}

// 滚动到底部监听
function reachBottom(distance=-1) {
	let reachBottomHeight = getScrollHeight() - getDocumentTop() - getWindowHeight()
	if (distance > -1) {
		if (reachBottomHeight == distance) {
			return true
		}
		return false
	} else {
		return reachBottomHeight
	}
}

//（浏览器窗口上边界内容高度）
function getDocumentTop() {
	var scrollTop = 0,
		bodyScrollTop = 0,
		documentScrollTop = 0;
	if (document.body) {
		bodyScrollTop = document.body.scrollTop;
	}
	if (document.documentElement) {
		documentScrollTop = document.documentElement.scrollTop;
	}
	scrollTop = bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
	// console.log('scrollTop:' + scrollTop);
	return scrollTop;
} //可视窗口高度（屏幕可以看见的高度）

function getWindowHeight() {
	var windowHeight = 0;
	if (document.compatMode == 'CSS1Compat') {
		windowHeight = document.documentElement.clientHeight;
	} else {
		windowHeight = document.body.clientHeight;
	}
	// console.log('windowHeight:' + windowHeight);
	return windowHeight;
} //滚动条滚动高度（即整个网页的高度）

function getScrollHeight() {
	var scrollHeight = 0,
		bodyScrollHeight = 0,
		documentScrollHeight = 0;
	if (document.body) {
		bodyScrollHeight = document.body.scrollHeight;
	}
	if (document.documentElement) {
		documentScrollHeight = document.documentElement.scrollHeight;
	}
	scrollHeight = bodyScrollHeight - documentScrollHeight > 0 ? bodyScrollHeight : documentScrollHeight;
	// console.log('scrollHeight:' + scrollHeight);
	return scrollHeight;
}

export default {
	backTop,
	reachBottom,
	stopPageScroll,
	isMobile
}


// WEBPACK FOOTER //
// ./src/global.js